module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-banner.fa9d0134.jpg";